export default __webpack_public_path__ + "static/media/bolsa.29487388.jpg";